import { useNavigate } from 'react-router-dom';
import { ROUTE_PACKAGE_BASE_URL } from '@src/constants/URLS.const';
import { useGetPromotionsQuery } from '@src/services/promotion/promotionApiSlice';
import { PromotionGallery } from '@src/components/PromotionGallery';
import { CardsSkeleton } from '@src/components/Loading/CardsSkeleton';

export function Promotions() {
  const navigate = useNavigate();
  const { data: promotions, isLoading } = useGetPromotionsQuery({});

  const handlePromotionClick = (countryId: string) => {
    navigate(`${ROUTE_PACKAGE_BASE_URL}?countryId=${countryId}`);
  };

  if (isLoading) return <CardsSkeleton numberOfItems={2} />;

  return (
    <div className='!mt-6 custom-scrollbar'>
      {promotions && promotions?.length > 0 && (
        <>
          <p className='mb-4 font-bold text-wl-on-background text-M-20'>
            Promotions
          </p>

          <PromotionGallery
            promotions={promotions}
            onPromotionClick={handlePromotionClick}
          />
        </>
      )}
    </div>
  );
}
